import { Extension, findParentNode } from '@tiptap/core';
import {
  NodeSelection,
  Plugin,
  PluginKey,
  TextSelection,
} from '@tiptap/pm/state';
import { Fragment, Slice, Node, DOMSerializer } from '@tiptap/pm/model';
import { EditorView } from '@tiptap/pm/view';
import { serializeForClipboard } from './clipboard-serializer';
import RightMenu from '@/components/RightMenu'
import {
  copyTextToClipboard, decodeDeeplink, generateUUID2,
  getYouTubeThumbnailUrl, isDarkMode,
  isDeepLink, isInDraw, isValidYYYYMMDD,
  sleep
} from "@/utils";
import { imgServer } from '@/components/EditorV2/imgServer'
import html2canvas from "html2canvas";
import * as model from '@model'
import { t } from 'i18next';
import {batchCardHighlight, getAllCardList, getCardById, getCardList, updateCard} from '@model/card';
import {EVENT_REFRESH_LIBRARY_LIST, EVENT_UPDATE_NOTE, KEY_FILE_DIR} from "@/Const";
import {ipcInvoke, ipcSend} from "@/common/ipc";
import {findChildren, NodePos} from "@/components/EditorV2/extension-youtube/dist/packages/core/src";
import {getAllHighlightContent} from "@/Utility0";
import { DatePicker } from '@/components/DatePickerPop/DatePickerManager';
import { message } from 'antd';
import {isMac} from "@/Utility";
import {APP_WEB} from "@/electron_interactive";
import { Template } from "@/components/TemplateDialog/TemplateManager";

let selectedDragNode: any = null
let selectedDragParentNode: any = null
let selectedDragDocPos: number = -1;
export interface GlobalDragHandleOptions {
  /**
   * The width of the drag handle
   */
  dragHandleWidth: number;

  /**
   * Whether to show the handle even when the editor is not editable (read-only).
   * Useful for canvas-rendered cards where the editor is often non-editable but we still
   * want the block icon + menu on hover.
   */
  showWhenNotEditable?: boolean;

  /**
   * The treshold for scrolling
   */
  scrollTreshold: number;

  /*
   * The css selector to query for the drag handle. (eg: '.custom-handle').
   * If handle element is found, that element will be used as drag handle. If not, a default handle will be created
   */
  dragHandleSelector?: string;

  /**
   * Tags to be excluded for drag handle
   */
  excludedTags: string[];

  /**
   * Custom nodes to be included for drag handle
   */
  customNodes: string[];
  callback:any;
  from?:string;
}


function getFixedContainingBlock(node: Element) {
  // See `absoluteRect()` for why this matters.
  return node.closest('[role="dialog"], .excalidraw__embeddable-container');
}

function getScaleFromTransform(el: Element) {
  const transform = window.getComputedStyle(el).transform;
  if (!transform || transform === "none") return 1;
  try {
    // DOMMatrixReadOnly works with `matrix()` and `matrix3d()`.
    const m = new DOMMatrixReadOnly(transform);
    // scaleX is sqrt(a^2 + b^2) (handles rotation as well).
    const scaleX = Math.sqrt(m.a * m.a + m.b * m.b);
    return scaleX || 1;
  } catch {
    return 1;
  }
}

function absoluteRect(node: Element) {
  const data = node.getBoundingClientRect();
  // NOTE:
  // `.drag-handle` is `position: fixed`. When an ancestor has `transform`, that ancestor
  // becomes the containing block for the fixed element. In canvas cards, the container
  // is scaled (pan/zoom), so we must convert viewport coordinates -> local CSS px by
  // dividing by the container scale, otherwise the icon will drift (typically downwards).
  const fixedContainingBlock = getFixedContainingBlock(node);

  if (
      fixedContainingBlock &&
      window.getComputedStyle(fixedContainingBlock).transform !== "none"
  ) {
    const containerRect = fixedContainingBlock.getBoundingClientRect();
    const scale = getScaleFromTransform(fixedContainingBlock);
    return {
      top: (data.top - containerRect.top) / scale,
      left: (data.left - containerRect.left) / scale,
      width: data.width / scale,
    };
  }
  return {
    top: data.top,
    left: data.left,
    width: data.width,
  };
}

function nodeDOMAtCoords(
  coords: { x: number; y: number },
  options: GlobalDragHandleOptions,
) {
  const selectors = [
    'li',
    'p:not(:first-child)',
    'pre',
    'blockquote',
    'p', // 加上 
    'hr', //分隔线
    // 'h1',
    // 'h2',
    // 'h3',
    // 'h4',
    // 'h5',
    // 'h6',
    '.heading-container',
    // '.node-deeplink', // 内联卡片不需要
    '.node-table', //表格
    '.node-latexBlock', //数学块
    '[data-youtube-video]', // youtube
    ...options.customNodes.map((node) => `[data-type=${node}]`),
  ].join(', ');
  // debugger
  return document
    .elementsFromPoint(coords.x, coords.y)
    .find(
      (elem: Element) => {
        // 必须是editor内的元素
        // 过滤其他节点内的paragraph
        if (elem.tagName === 'P' && !elem.parentElement?.classList.contains('tiptap') && !elem.parentElement?.classList.contains('ProseMirror')) {
          return false
        }
        const isInTiptapEditor = elem.closest('.tiptap.ProseMirror');
        const isValidNode = elem.matches(selectors);
        return isInTiptapEditor && isValidNode;
      }
    );
}
function nodePosAtDOM(
  node: Element,
  view: EditorView,
  options: GlobalDragHandleOptions,
) {
  const boundingRect = node.getBoundingClientRect();

  return view.posAtCoords({
    left: boundingRect.left + 50 + options.dragHandleWidth,
    top: boundingRect.top + 1,
  })?.inside;
}

function calcNodePos(pos: number, view: EditorView) {
  const $pos = view.state.doc.resolve(pos);
  if ($pos.depth > 1) return $pos.before($pos.depth);
  return pos;
}

export function DragHandlePlugin(
  options: GlobalDragHandleOptions & { pluginKey: string },
) {
  let listType = '';
  let isDraggingHandleBlock = false;

  function hideLeftMenu() {
    try {
      const leftMenu = document.getElementById('div-tree-left-menu');
      if (leftMenu) {
        leftMenu.style.opacity = '0';
        leftMenu.style.pointerEvents = 'none';
      }
    } catch(e) {}
  }

  function restoreLeftMenu() {
    try {
      const leftMenu = document.getElementById('div-tree-left-menu');
      if (leftMenu) {
        leftMenu.style.opacity = '1';
        leftMenu.style.pointerEvents = 'auto';
      }
    } catch(e) {}
  }

  function handleDragStart(event: DragEvent, view: EditorView) {
    // 拖动开始
    if (!view.editable && !options.showWhenNotEditable) {
      console.log('[BlockDrag] blocked: not editable');
      return;
    }
    view.focus();
    hideLeftMenu();

    if (!event.dataTransfer) return;
    const node = nodeDOMAtCoords(
      {
        x: event.clientX + 50 + options.dragHandleWidth,
        y: event.clientY,
      },
      options,
    );


    if (!(node instanceof Element)) return;

    let draggedNodePos = nodePosAtDOM(node, view, options);
    if (draggedNodePos == null || draggedNodePos < 0) return;
    draggedNodePos = calcNodePos(draggedNodePos, view);

    const { from, to } = view.state.selection;
    const diff = from - to;

    const fromSelectionPos = calcNodePos(from, view);
    let differentNodeSelected = false;

    const nodePos = view.state.doc.resolve(fromSelectionPos);

    // Check if nodePos points to the top level node
    if (nodePos.node().type.name === 'doc') differentNodeSelected = true;
    else {
      const nodeSelection = NodeSelection.create(
        view.state.doc,
        nodePos.before(),
      );

      // Check if the node where the drag event started is part of the current selection
      differentNodeSelected = !(
        draggedNodePos + 1 >= nodeSelection.$from.pos &&
        draggedNodePos <= nodeSelection.$to.pos
      );
    }
    let selection = view.state.selection;
    if (
      !differentNodeSelected &&
      diff !== 0 &&
      !(view.state.selection instanceof NodeSelection)
    ) {
      const endSelection = NodeSelection.create(view.state.doc, to - 1);
      selection = TextSelection.create(
        view.state.doc,
        draggedNodePos,
        endSelection.$to.pos,
      );
    } else {
      selection = NodeSelection.create(view.state.doc, draggedNodePos);

      // if inline node is selected, e.g mention -> go to the parent node to select the whole node
      // if table row is selected, go to the parent node to select the whole node
      if (
        (selection as NodeSelection).node.type.isInline ||
        (selection as NodeSelection).node.type.name === 'tableRow' ||  node.tagName === 'BLOCKQUOTE' || node.tagName === 'hr' 
      ) {
        
        let $pos = view.state.doc.resolve(selection.from);
        selection = NodeSelection.create(view.state.doc, $pos.before());
      }
    }
    view.dispatch(view.state.tr.setSelection(selection));


    // If the selected node is a list item, we need to save the type of the wrapping list e.g. OL or UL
    if (
      view.state.selection instanceof NodeSelection &&
      view.state.selection.node.type.name === 'listItem'
    ) {
      listType = node.parentElement!.tagName;
    }

    const slice = view.state.selection.content();
    const { dom, text } = serializeForClipboard(view, slice);

    event.dataTransfer.clearData();
    event.dataTransfer.setData('text/html', dom.innerHTML);
    event.dataTransfer.setData('text/plain', text);
    event.dataTransfer.setData('application/x-render-note-block-drag', '1');
    event.dataTransfer.effectAllowed = 'copyMove';

    // Add a visual drag image so the browser recognizes this as a valid drag
    try {
      const dragGhost = node.cloneNode(true) as HTMLElement;
      dragGhost.style.position = 'absolute';
      dragGhost.style.top = '-9999px';
      dragGhost.style.opacity = '0.5';
      document.body.appendChild(dragGhost);
      event.dataTransfer.setDragImage(dragGhost, 0, 0);
      setTimeout(() => {
        if (dragGhost.parentNode) dragGhost.parentNode.removeChild(dragGhost);
      }, 100);
    } catch(e) {
      event.dataTransfer.setDragImage(node, 0, 0);
    }

    view.dragging = { slice, move: event.ctrlKey };
  }

  let dragHandleElement: HTMLElement | null = null;

  function hideDragHandle() {
    if (dragHandleElement) {
      dragHandleElement.classList.add('hide');
    }
  }

  function showDragHandle() {
    if (dragHandleElement) {
      dragHandleElement.classList.remove('hide');
    }
  }

  function hideHandleOnEditorOut(event: MouseEvent) {
    if (event.target instanceof Element) {
      // Check if the relatedTarget class is still inside the editor
      const relatedTarget = event.relatedTarget as HTMLElement;
      const isInsideEditor =
        relatedTarget?.classList.contains('tiptap') ||
        relatedTarget?.classList.contains('drag-handle');

      if (isInsideEditor) return;
    }
    hideDragHandle();
  }

  return new Plugin({
    key: new PluginKey(options.pluginKey),
    view: (view) => {
      const handleBySelector = options.dragHandleSelector
          ? view.dom.parentElement?.querySelector<HTMLElement>(options.dragHandleSelector)
          : null;
      dragHandleElement = handleBySelector ?? document.createElement('div');
      dragHandleElement.draggable = true;
      dragHandleElement.dataset.dragHandle = '';
      dragHandleElement.classList.add('drag-handle');
      async function dragClick(event: MouseEvent) {
        if (isDraggingHandleBlock) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        let editorView = view.dom.editor;

        if (
            selectedDragNode.type.name === "deeplink" ||
            selectedDragNode.type.name === "latexInline"
        ) {
          selectedDragNode = selectedDragParentNode;
        }

        const isTableRelated =
            selectedDragNode.type.name === "table" ||
            selectedDragNode.type.name === "tableCell" ||
            selectedDragNode.type.name === "tableHeader" ||
            selectedDragNode.type.name === "tableRow";

        let selectNodeNP: any;
        if (isTableRelated && typeof selectedDragDocPos === "number" && selectedDragDocPos >= 0) {
          const hoverResolved = editorView.state.doc.resolve(selectedDragDocPos);
          // 向上找到 table 节点
          let tableFrom: number | null = null;
          if (hoverResolved.nodeAfter?.type?.name === "table") {
            tableFrom = hoverResolved.pos;
          } else {
            for (let d = hoverResolved.depth; d > 0; d--) {
              if (hoverResolved.node(d)?.type?.name === "table") {
                tableFrom = hoverResolved.before(d);
                break;
              }
            }
          }
          if (tableFrom !== null) {
            const tableResolved = editorView.state.doc.resolve(tableFrom);
            const tableNode = tableResolved.nodeAfter;
            if (tableNode) {
              selectNodeNP = { node: tableNode, from: tableFrom, to: tableFrom + tableNode.nodeSize };
            }
          }
        }

        // 非 table 类节点，或 table 定位失败时，回退到 id 查找
        if (!selectNodeNP) {
          selectNodeNP = editorView.$doc.querySelectorAll(
              selectedDragNode.type.name,
              { id: selectedDragNode.attrs.id }
          )[0];
        }

        const resolvedPos = editorView.state.doc.resolve(
            selectNodeNP.from
        );
        const selectParentNode = resolvedPos.node(resolvedPos.depth - 1);

        // 检查 paragraph 节点是否含有 latexInline / deeplink 内联节点
        // （mousemove 时无法区分 paragraph 内的内联节点类型，需在此处检测）
        // 只要段落中包含这类内联节点，就不提供 add to highlight
        const isInlineOnlyParagraph = (() => {
          const node = selectNodeNP?.node;
          if (node?.type?.name !== "paragraph") return false;
          let hasInlineNode = false;
          node.forEach((child: any) => {
            if (child.type.name === "latexInline" || child.type.name === "deeplink") {
              hasInlineNode = true;
            }
          });
          return hasInlineNode;
        })();



        // let selectNodeNP:NodePos = editorView.$doc.querySelectorAll(szType, { id: selectedDragNode.attrs.id })[0];
        // let nFrom = 0;
        // if (!selectNodeNP){
        //   if (szType == 'deeplink'){
        //     //需要去父级查找....
        //     editorView.state.doc.descendants((node,pos)=>{
        //       if (node.attrs.id == selectedDragNode.attrs.id){
        //         nFrom = pos;
        //
        //         const resolvedPos0 = editorView.state.doc.resolve(nFrom);
        //         const parentNode = resolvedPos0.parent;
        //         selectNodeNP = editorView.$doc.querySelectorAll('paragraph', { id: parentNode.attrs.id })[0];
        //       }
        //     })
        //   }
        // }else{
        //   nFrom = selectNodeNP.from;
        // }
        // const resolvedPos = editorView.state.doc.resolve(nFrom);
        // const selectParentNode = resolvedPos.node(resolvedPos.depth - 1);

        // 检查是否在模板编辑器弹窗内
        const isInTemplateDialog = !!view?.dom?.closest('.template-editor-dialog');

        const menusInTemplate = [
          {
            label: t('Delete'),
            key: 'Delete',
          },
          {
            label: t('Duplicate'),
            key: 'Duplicate',
          }
        ]

        let menus = [
          {
            label: t('Delete'),
            key: 'Delete',
          },
          {
            label: t('Duplicate'),
            key: 'Duplicate',
          },
          {
            label: t('Copy link to block'),
            key: 'Copy link to block'
          },
          {
            label: t('Add to highlight'),
            key: 'addToHighlight'
          },
        ]

        const deeplinkCardMenus = [
          {
            label: t('Delete'),
            key: 'Delete',
          },
          {
            label: t('Duplicate'),
            key: 'Duplicate',
          },
          {
            label: t('Show info'),
            key: 'showInfo'
          }
        ]

        const deeplinkFileMenus = [
          {
            label: t('Delete'),
            key: 'Delete',
          },
          {
            label: t('Duplicate'),
            key: 'Duplicate',
          },
          {
            label: t('Copy link to block'),
            key: 'Copy link to block'
          },
          {
            label: t('Show info'),
            key: 'showInfo'
          },
          {
            label:'',
            key: 'sep_1',
            type:'divider'
          },
          {
            label: t('Open in default app'),
            key: 'openInDefaultApp'
          },
          {
            label: isMac()?t('Show in finder'):t('Show in system exporler'),
            key: 'showInFinder'
          }
        ]

        let szType = selectedDragNode.type.name;
        // let selectedDeeplinkNode;
        if (szType == 'paragraph'){
          //这里比较恶心的是 selectedDragNode 有时候定位在deeplink 有时候又定位在deeplink的父级
          if (selectedDragNode.childCount > 0){
            const childNode = selectedDragNode.child(0);
            if (childNode?.type?.name == 'deeplink'){
              selectedDragNode = childNode;
              szType = 'deeplink';
            }
          }
        }

        // todoItem增加修改截止日期
        if (selectedDragNode.type.name === 'paragraph' && selectParentNode.type.name === "taskItem") {
          // menus.push({
          //   label: t('Change duedate'),
          //   key: 'Change duedate'
          // })
        }

        // 判断是否显示创建模板选项
        const hasSelection = editorView.state.selection.content().size > 0;
        const isImageOrYoutube = selectedDragNode.type.name === "image" || selectedDragNode.type.name === "youtube";
        if (hasSelection || !isImageOrYoutube) {
          menus.push({
            label: t("Create template"),
            key: "Create template",
          });
        }

        if (!selectedDragNode)return;

        if (isInTemplateDialog){
          menus = menusInTemplate;
        }

        let arrayMenu = menus;
        let deeplink;
        if (szType == 'deeplink'){
          if (isDeepLink(selectedDragNode.attrs?.href)){
            deeplink = decodeDeeplink(selectedDragNode.attrs.href);
            if (deeplink.childType == 'card' ||
                deeplink.childType == 'cardAnno' ||
                deeplink.childType == 'pdfAnno' ||
                deeplink.childType == 'videoAnno' ||
                deeplink.childType == 'audioAnno'){
              arrayMenu = deeplinkCardMenus;
            }else if(deeplink.childType == 'pdf' || deeplink.childType == 'video' || deeplink.childType == 'audio' || deeplink.childType == 'file'){
              arrayMenu = deeplinkFileMenus;
            }
          }
        }
        if (
            selectNodeNP?.node?.type?.name !== "table" &&
            selectNodeNP?.node?.type?.name !== "tableCell" &&
            selectNodeNP?.node?.type?.name !== "tableHeader" &&
            selectNodeNP?.node?.type?.name !== "tableRow" &&
            !isInlineOnlyParagraph
        ) {

        }else{
          //移除
          const nIndex = arrayMenu.findIndex(p=>p.key == 'addToHighlight');
          if (nIndex != -1){
            arrayMenu.splice(nIndex,1);
          }
        }

        const key = await RightMenu.open(event.pageX, event.pageY, arrayMenu)

        let isDeeplinkNode = selectedDragNode.type.name==='deeplink';
        if(selectedDragParentNode && (selectedDragNode.type.name==='deeplink' || selectedDragNode.type.name==='latexInline')){
          selectedDragNode = selectedDragParentNode
        }

        // 获取listitem的from和to
        let from = 0
        let to = 0
        try {
          const parentResolvedPos = editorView.state.doc.resolve(resolvedPos.start(resolvedPos.depth - 1));
          from = parentResolvedPos.start(parentResolvedPos.depth);
          to = parentResolvedPos.end(parentResolvedPos.depth);
        } catch (error) {

        }


        if (key === 'Delete') {
          let deleteFrom = 0;
          let nTo = selectNodeNP.to;

          if (selectedDragNode.type.name === 'paragraph' && (selectParentNode.type.name === "listItem" || selectParentNode.type.name === "taskItem")) {
            // editorView.commands.deleteRange({ from: from - 1, to: to - 1 })
            const selectGrandParentNode = resolvedPos.node(resolvedPos.depth - 2);
            if (selectGrandParentNode.childCount === 1) {
              deleteFrom = from - 2;
              editorView.commands.deleteRange({ from: from - 2, to: to - 1 })
            } else {
              deleteFrom = from - 1;
              editorView.commands.deleteRange({ from: from - 1, to: to - 1 })
            }
          }  else if (selectedDragNode.type.name === 'paragraph' && selectParentNode.type.name === "blockquote") {
            deleteFrom = from - 1;
            editorView.commands.deleteRange({ from: from - 1, to: to - 1 })
          } else if (
              selectedDragNode.type.name === "tableCell" ||
              selectedDragNode.type.name === "tableHeader" ||
              selectedDragNode.type.name === "table"
          ) {
            // 通过 hover 时记录的真实文档位置向上定位所属 table，避免多表格时命中错误的表格
            const hoverPos =
                typeof selectedDragDocPos === "number" && selectedDragDocPos >= 0
                    ? selectedDragDocPos
                    : selectNodeNP.from;
            const hoverResolvedPos = editorView.state.doc.resolve(hoverPos);
            let tableFrom: number | null = null;
            let tableTo: number | null = null;
            // 情况1：hoverPos 正好在 table 节点前
            if (hoverResolvedPos.nodeAfter?.type?.name === "table") {
              tableFrom = hoverResolvedPos.pos;
              tableTo = tableFrom + hoverResolvedPos.nodeAfter.nodeSize;
            } else {
              // 情况2：hoverPos 在 table 内部（tableCell / tableHeader / tableRow）
              for (let d = hoverResolvedPos.depth; d > 0; d--) {
                if (hoverResolvedPos.node(d)?.type?.name === "table") {
                  tableFrom = hoverResolvedPos.before(d);
                  tableTo = hoverResolvedPos.after(d);
                  break;
                }
              }
            }
            if (tableFrom !== null && tableTo !== null) {
              deleteFrom = tableFrom;
              editorView.commands.deleteRange({
                from: tableFrom,
                to: tableTo,
              });
            }
          }  else {
            if (selectedDragNode.type.name == 'image' || isDeeplinkNode){
              editorView.commands.deleteRange({from: selectNodeNP.from, to: selectNodeNP.from + 1});
            }else if (selectedDragNode.type.name == 'youtube'){
              editorView.commands.deleteRange({from: selectNodeNP.from, to: selectNodeNP.from + 1});
            }
            else if (selectParentNode?.type?.name?.includes('table')){
              let tableSelectNodeNP = editorView.$doc.querySelectorAll('tableRow', { id: selectParentNode.attrs.id })[0]
              editorView.commands.deleteRange({ from: tableSelectNodeNP.from, to: tableSelectNodeNP.to + 1 })
            }
            else{
              editorView.commands.deleteRange({ from: selectNodeNP.from - 1, to: selectNodeNP.to - 1 })
            }
          }

          if (nTo < editorView.state.doc.content.size){
            editorView.chain().focus().setTextSelection({from:selectNodeNP.from -1,to:selectNodeNP.from -1}).run();
          }

          // 删除后将光标定位到删除位置----test,,,可以不要
          // setTimeout(() => {
          //   try {
          //     const { state, dispatch } = editorView.view;
          //     const newPos = Math.min(Math.max(deleteFrom, 0), state.doc.content.size);
          //     const $pos = state.doc.resolve(newPos);
          //     const tr = state.tr.setSelection(TextSelection.near($pos, 1));
          //     dispatch(tr);
          //     editorView.commands.focus();
          //   } catch (err) {
          //     // 如果设置选择失败，至少聚焦编辑器
          //     editorView.commands.focus();
          //   }
          // }, 10);


          // if (selectNodeNP) {
          //   try{
          //     //
          //     let nTo = selectNodeNP.to;
          //     if (nTo > editorView.state.doc.content.size){
          //       nTo = editorView.state.doc.content.size;
          //       const t = editorView.commands.deleteRange({from: selectNodeNP.from -1 , to: nTo});
          //     }else {
          //       //这些东西怎么删不掉呢。。。
          //       if (selectedDragNode.type.name == 'deeplink' || selectedDragNode.type.name == 'image') {
          //         editorView.commands.deleteRange({from: selectNodeNP.from, to: selectNodeNP.from + 1});
          //       } else {
          //         editorView.commands.deleteRange({
          //           from: selectNodeNP.from - 1,
          //           to: selectNodeNP.to - 1
          //         });
          //       }
          //     }
          //
          //     editorView.chain().focus().setTextSelection({from:selectNodeNP.from -1,to:selectNodeNP.from -1}).run();
          //   }catch (e){
          //     console.log('delete range fail....')
          //     editorView.commands.deleteRange({from: selectNodeNP.from - 1, to: selectNodeNP.to-1})
          //   }
          // }
        } else if (key === 'Duplicate') {
          //region 如果选中的是 tableCell，则提升到其所属 table 再进行复制
          const hoverResolvedPos =
              typeof selectedDragDocPos === "number" && selectedDragDocPos >= 0
                  ? editorView.state.doc.resolve(selectedDragDocPos)
                  : resolvedPos;

          const findTableAtPos = ($pos: any) => {
            // 情况1：当前位置正好在 table 节点前
            if ($pos?.nodeAfter?.type?.name === "table") {
              const node = $pos.nodeAfter;
              const from = $pos.pos;
              const to = from + node.nodeSize;
              return { node, from, to };
            }
            // 情况2：当前位置在 table 内部（例如 tableCell / tableRow）
            for (let d = $pos.depth; d > 0; d--) {
              const n = $pos.node(d);
              if (n?.type?.name === "table") {
                return { node: n, from: $pos.before(d), to: $pos.after(d) };
              }
            }
            return null;
          };

          let nodeToDuplicate: any = selectNodeNP.node;
          let insertPos = selectNodeNP.to - 1;

          // 表格相关节点：以 hover 的 doc 位置为准定位所属 table，避免总命中第一个表格
          if (
              selectedDragNode.type.name === "table" ||
              selectedDragNode.type.name === "tableCell" ||
              selectedDragNode.type.name === "tableHeader" ||
              selectedDragNode.type.name === "tableRow"
          ) {
            const info = findTableAtPos(hoverResolvedPos);
            if (info) {
              nodeToDuplicate = info.node;
              insertPos = info.to - 1;
            }
          }

          let dupNP = JSON.parse(JSON.stringify(nodeToDuplicate));

          if (nodeToDuplicate?.type?.name === "table") {
            // table 复制时，第一行也需要新的 id（保持与现有逻辑一致）
            dupNP.content?.[0]?.attrs &&
            (dupNP.content[0].attrs.id = crypto.randomUUID());
          }
          dupNP.attrs && (dupNP.attrs.id = crypto.randomUUID());

          if (nodeToDuplicate?.type?.name === "latexBlock") {
            editorView.commands.insertContentAt(
                selectNodeNP.to,
                dupNP
            );
          } else if (
              selectedDragNode.type.name === "paragraph" &&
              (selectParentNode.type.name === "listItem" ||
                  selectParentNode.type.name === "taskItem")
          ) {
            let dupNP_listitem = JSON.parse(JSON.stringify(selectParentNode));
            dupNP_listitem.attrs.id = crypto.randomUUID();
            editorView.commands.insertContentAt(
                to - 1,
                dupNP_listitem
            );
          } else {
            editorView.commands.insertContentAt(insertPos, dupNP);
          }
          //endregion
        } else if (key === 'Copy link to block') {
          //region 表格类节点：selectNodeNP 已统一定位为完整 table 节点，用它的 id 和类型
          // 其他节点：直接用 selectedDragNode 的信息
          const linkNode = isTableRelated ? selectNodeNP?.node : selectedDragNode;
          const linkBlockId = linkNode?.attrs?.id ?? selectedDragNode.attrs.id;
          const linkBlockType = isTableRelated ? "table" : selectedDragNode.type.name;
          // let szCardId = sessionStorage.getItem("note-id");
          let blockAdress = `noteey://open?note=${(editorView.cardId)}&&blockid=${linkBlockId}&&blocktype=${linkBlockType}`
          copyTextToClipboard(blockAdress)
          message.info(t('Link copied to clipboard'));
          //endregion
        } else if (key === 'add to highlight' || key == "addToHighlight") {
          //region add to highlight
          const oriHighlights = getAllHighlightContent(editorView);

          if (selectedDragNode.type.name === 'paragraph' || selectedDragNode.type.name === 'heading' || selectedDragNode.type.name === 'blockquote' || selectedDragNode.type.name === 'table') {
            editorView
              .chain()
              .focus()
              .setTextSelection({ from: selectNodeNP.from, to: selectNodeNP.to })  // 设置文本选择范围
                .setHighlight({ color: isDarkMode()?'#BDAA47':'#FCEC96' })
              .setHighlightId(crypto.randomUUID(), selectNodeNP.from)
              .run();
          }
          if (selectedDragNode.type.name === 'taskList' || selectedDragNode.type.name === 'bulletList' || selectedDragNode.type.name === 'orderedList') {
            // 对block添加highlight标记
            selectNodeNP.node.attrs = { ...selectNodeNP.node.attrs, blockHighlight: true }
            editorView
              .chain()
              .focus()
              .setTextSelection({ from: selectNodeNP.from, to: selectNodeNP.to })  // 设置文本选择范围
                .setHighlight({ color: isDarkMode()?'#BDAA47':'#FCEC96' })
              .run();
          }
          if (selectedDragNode.type.name === 'deeplink' || selectedDragNode.type.name === 'codeBlock') {
            // 不能使用该highlight方法

          }

          // 对image，youtube，blockLatex元素进行截图
          if (selectedDragNode.type.name === 'image') {
            // 截图并增加该图片的属性
            selectNodeNP.node.attrs = { ...selectNodeNP.node.attrs, highlightImgUrl: selectNodeNP.node.attrs.src }
            document.dispatchEvent(new CustomEvent('changeHighlight'));
            document.dispatchEvent(new CustomEvent('refreshSidebar'));
          }
          if (selectedDragNode.type.name === 'youtube') {
            // 截图并增加该图片的属性
            const imageUrl = getYouTubeThumbnailUrl(selectNodeNP.node.attrs.src)
            const id = imgServer.downUrl(imageUrl)
            selectNodeNP.node.attrs = { ...selectNodeNP.node.attrs, highlightImgUrl: `atom://${id}.jpeg` }
            await sleep(400)
            document.dispatchEvent(new CustomEvent('changeHighlight'));
            document.dispatchEvent(new CustomEvent('refreshSidebar'));
          }
          if (selectedDragNode.type.name === 'latexBlock') {
            const latexElement = document.querySelector(`.latexBlock[data-id="${selectedDragNode.attrs.id}"]`);
            html2canvas(latexElement, {
              scale: 4,
              logging: false,
              useCORS: true,
              x: 0,
              y: 0,
              width: latexElement?.clientWidth,
              // height: 30,
              backgroundColor: "#ffffff",
            }).then(canvas => {
              // 将截图的 Base64 数据提取出来
              const base64Image = canvas.toDataURL();
              const id = crypto.randomUUID();
              model.addImg(id, base64Image)
              selectNodeNP.node.attrs = { ...selectNodeNP.node.attrs, highlightImgUrl: `atom://${id}.jpeg` }
              // 主动触发事件
              document.dispatchEvent(new CustomEvent('changeHighlight'));
              document.dispatchEvent(new CustomEvent('refreshSidebar'));
            }).catch(error => {
              console.error('截图失败:', error);
            });
          }

          setTimeout(async ()=>{
            //保存card
            // await saveDataToDB();
            await options.callback('saveDb');

            const highlights = getAllHighlightContent(editorView);
            //找id 不同的一个.
            for (let i=0;i<highlights.content.length;i++){
              const hiItem = highlights.content[i];
              const itemm = oriHighlights.content.find(p=>p.id == hiItem.id);
              if (!itemm){
                //不存在，就是这个ID了。
                window.showMessageTip(t("Highlight saved"),t("Manage tags"),"manageTag",{id:hiItem.id,buttonTxt1:t('Add a note')});
                break;
              }
            }

            const data = await options.callback('getData');

            batchCardHighlight(highlights.content,data?.id,data?.name).then(res=>{
              postMessage(EVENT_REFRESH_LIBRARY_LIST);
            });
          },600)
          //endregion
        }else if (key == 'showInfo'){
          //region showinfo
          getCardById(deeplink?.id).then(res=>{
            if (res){
              window.showInfo('library',res);
            }
          })
          //endregion
        }else if (key == 'openInDefaultApp'){
          getCardById(deeplink?.id).then(res=>{
            let szFilePath = localStorage.getItem(KEY_FILE_DIR) + res.fileName;
            if (res.isAbsolutePath){
              szFilePath = res.fileName;
            }
            ipcInvoke('open-url-withwhen',szFilePath);
          })
        }else if (key == 'showInFinder'){
          getCardById(deeplink?.id).then(res=>{
            let szFilePath = localStorage.getItem(KEY_FILE_DIR) + res.fileName;
            if (res.isAbsolutePath){
              szFilePath = res.fileName;
            }
            ipcSend("show-in-exporler",szFilePath)
          })
        }else if (key === 'Change duedate') {
          //region change duedate
          try {
            // 在鼠标点击位置显示日历弹窗
            const selectedDate = await DatePicker.open(event.pageX, event.pageY, (date: string) => { }, selectParentNode.attrs.dueDate);
            let anotherFormatDate = selectedDate.replace(/-/g, "")

            const currentNoteName = sessionStorage.getItem('currentNoteName')

            if (currentNoteName && isValidYYYYMMDD(currentNoteName) && selectedDate !== '-1' && currentNoteName !== anotherFormatDate) {
              // 针对需要移动todo的特殊逻辑
              // 判断目标卡片是否存在  没有就添加
              const allNote:any = await getCardList(-1,0,['card','journal'],'','');
              let targetCard = allNote.find(card => card.name === anotherFormatDate)
              let existCard
              if (!targetCard) {
                // 先添加笔记
                existCard = await updateCard({
                  id: generateUUID2(),
                  doc: "<p ifhidden=\"false\"></p>",
                  type: "card",
                  name: anotherFormatDate,
                })
                await sleep(200)
              } else {
                existCard = targetCard;
              }
              {
                // 将元素添加到目标笔记末尾
                // 需要修改task的duedate!!!
                try {
                  const year = parseInt(anotherFormatDate.slice(0, 4), 10);
                  const month = parseInt(anotherFormatDate.slice(4, 6), 10) - 1; // JS月份从0开始
                  const day = parseInt(anotherFormatDate.slice(6, 8), 10);
                  const date = new Date(year, month, day, 12, 0, 0); // 中午12点
                  const { state, view } = window.publicEditor;
                  const { schema } = state;

                  // 先设置内容
                  window.publicEditor?.commands.setContent(existCard.thumbHtml);

                  // 重新获取最新的状态
                  const newState = view.state;
                  const { doc, tr } = newState;

                  const paragraph = schema.nodes.paragraph.create(null,schema.text(selectNodeNP.textContent));
                  const task = schema.nodes.taskItem.create(
                      {
                        checked: false,
                        id: crypto.randomUUID(),
                        listFold: false,
                        dueDate: String(date.getTime()),
                      },
                      paragraph
                  );

                  const endPos = doc.content.size;
                  const transaction = tr.insert(endPos, task);
                  view.dispatch(transaction);
                  // 保存
                  const html = imgServer.parserImgFromHtml(window.publicEditor?.getHTML() as string);
                  const data = {
                    ...existCard,
                    doc: html,
                  };
                  await updateCard(data);
                } catch (error) {
                  console.log(333,error)
                }
              }
              {
                // 将元素从原笔记中删除
                const { state, view } = editorView;
                const { doc, tr } = state;
                const parentResolvedPos = state.doc.resolve(resolvedPos.start(resolvedPos.depth - 1));
                const from = parentResolvedPos.start(parentResolvedPos.depth);
                const to = parentResolvedPos.end(parentResolvedPos.depth);
                view.dispatch(tr.delete(from - 2, to));
                // // 保存
                // const html_source = imgServer.parserImgFromHtml(editor?.getHTML() as string);
                // const name_source = note?.name;
                // let createTime_source = note.createTime;
                // let updateTime_source = Date.now();
                // if (!createTime_source) {
                //   createTime_source = updateTime_source;
                // }
                // const data_source = {
                //   doc: html_source,
                //   thumbHtml: html_source,
                //   id: note.id,
                //   type: 'card',
                //   isDeleted: 0,
                //   name: name_source || '',
                //   createTime: createTime_source,
                //   updateTime: updateTime_source
                // };
                // postMessage(EVENT_UPDATE_NOTE, { data: data_source, isInsertCanvas: false, isAutoSave: true });
              }
            } else {
              const targetNode = editorView.$doc.querySelectorAll('taskItem', {
                id: selectParentNode.attrs.id
              })[0];
              let tr = editorView.view.state.tr.setNodeMarkup(targetNode.pos - 1, editorView.view.state.schema.nodes.taskItem, {
                ...selectParentNode.attrs,
                dueDate: selectedDate === '-1' ? '-1' : new Date(`${selectedDate}T12:00:00`).getTime()
              });
              editorView.view.dispatch(tr)
            }
          } catch (error) {
          }
          //endregion
        }else if (key == 'Create template'){
          //region create template
          let dom: HTMLElement;

          // 判断是否有选区内容
          const hasSelection = editorView.state.selection.content().size > 0;

          if (hasSelection) {
            // 有选区时，获取选中内容的HTML
            const slice = view.state.selection.content();
            const serialized = serializeForClipboard(view, slice);
            dom = serialized.dom;

            // 修正嵌套 list 的问题：如果 dom 中只有 li 元素没有外层 ol/ul，需要包裹正确的列表类型
            const topLevelLis = Array.from(dom.children).filter(
                (child) => child.tagName === 'LI'
            );
            if (topLevelLis.length > 0 && dom.children.length === topLevelLis.length) {
              // 检查选区起始位置的父节点类型来确定应该用 ol 还是 ul
              const { from } = view.state.selection;
              const $from = view.state.doc.resolve(from);
              let listType = 'ul'; // 默认 ul

              // 向上查找最近的 list 类型
              for (let depth = $from.depth; depth > 0; depth--) {
                const node = $from.node(depth);
                if (node.type.name === 'orderedList') {
                  listType = 'ol';
                  break;
                } else if (node.type.name === 'bulletList') {
                  listType = 'ul';
                  break;
                } else if (node.type.name === 'taskList') {
                  listType = 'ul';
                  break;
                }
              }

              // 用正确的列表类型包裹 li 元素
              const wrapper = document.createElement(listType);
              while (dom.firstChild) {
                wrapper.appendChild(dom.firstChild);
              }
              dom.appendChild(wrapper);
            }
            //endregion
          } else {
            // 没有选区时，根据节点类型获取当前 block 的内容
            const tempDiv = document.createElement('div');
            const serializer = DOMSerializer.fromSchema(view.state.schema);

            if (
                selectedDragNode.type.name === "paragraph" &&
                (selectParentNode.type.name === "listItem" ||
                    selectParentNode.type.name === "taskItem")
            ) {
              // 如果是 list 中的 paragraph，获取整个 list
              const selectGrandParentNode = resolvedPos.node(resolvedPos.depth - 2);
              tempDiv.appendChild(serializer.serializeNode(selectGrandParentNode));
            } else if (
                selectedDragNode.type.name === "paragraph" &&
                selectParentNode.type.name === "blockquote"
            ) {
              // 如果是 blockquote 中的 paragraph，获取整个 blockquote
              tempDiv.appendChild(serializer.serializeNode(selectParentNode));
            } else if (
                selectedDragNode.type.name === "tableCell" ||
                selectedDragNode.type.name === "tableHeader" ||
                selectedDragNode.type.name === "table" ||
                selectedDragNode.type.name === "tableRow"
            ) {
              // selectNodeNP.node 已在 dragClick 开头统一定位为整个 table 节点
              tempDiv.appendChild(serializer.serializeNode(selectNodeNP.node));
            } else {
              // 其他情况，获取当前节点
              tempDiv.appendChild(serializer.serializeNode(selectNodeNP.node));
            }

            dom = tempDiv;
          }

          // 清理不需要保存到模板的元素（图片、YouTube视频）
          // 移除图片元素
          dom.querySelectorAll('img:not(.list-image):not(.heading-image)').forEach((img: Element) => img.remove());
          // 移除 YouTube 视频元素
          dom.querySelectorAll('[data-youtube-video], iframe[src*="youtube"]').forEach((el: Element) => el.remove());
          // 移除图片节点容器（如果有）
          dom.querySelectorAll('[data-type="image"], .node-image').forEach((el: Element) => el.remove());

          const selectedHtml = dom.innerHTML;
          // 取消选中内容并失焦
          const { from } = editorView.state.selection;
          editorView.commands.setTextSelection(from);
          editorView.commands.blur();

          //打开模板创建弹窗，传入选中内容
          const templateResult = await Template.open(selectedHtml);
          if (templateResult) {
            console.log("Template created:", templateResult.title);
          }
        }
      }
      dragHandleElement.addEventListener('click', dragClick)

      let hasLoggedDragOver = false;

      function getResolvedDropPos(e: DragEvent, view: EditorView) {
        const rect = view.dom.getBoundingClientRect();
        // Clamp clientX to be inside the editor. This is crucial when dragging the drag handle
        // which is physically located outside the left boundary of the editor, causing
        // the initial posAtCoords to fail and fallback to the document end.
        let clampedX = e.clientX;
        if (clampedX < rect.left) clampedX = rect.left + 5;
        if (clampedX > rect.right) clampedX = rect.right - 5;

        let dropPos = view.posAtCoords({ left: clampedX, top: e.clientY });
        if (!dropPos) {
          if (e.clientY < rect.top + 20) {
            const res = view.posAtCoords({ left: clampedX, top: rect.top + 5 });
            if (res) dropPos = res;
          } else if (e.clientY > rect.bottom - 20) {
            const res = view.posAtCoords({ left: clampedX, top: rect.bottom - 5 });
            if (res) dropPos = res;
            else {
              dropPos = { pos: view.state.doc.content.size - 1, inside: view.state.doc.content.size - 1 };
            }
          }
        }
        if (!dropPos) {
          const elems = document.elementsFromPoint(clampedX, e.clientY);
          let targetNode = null;
          let targetRect = null;
          for (const el of elems) {
            if (['P', 'LI', 'H1', 'H2', 'H3', 'DIV'].includes(el.tagName) && el.closest('.ProseMirror')) {
              targetNode = el;
              targetRect = el.getBoundingClientRect();
              break;
            }
          }
          if (targetNode && targetRect) {
            const relativeY = e.clientY - targetRect.top;
            const attempts = [ relativeY, targetRect.height / 2, 5, targetRect.height - 5 ];
            for (const y of attempts) {
              const resolved = view.posAtCoords({ left: clampedX, top: targetRect.top + y });
              if (resolved) { dropPos = resolved; break; }
            }
          }
        }
        if (!dropPos && e.target instanceof HTMLElement) {
          const closestBlock = e.target.closest('p, li, h1, h2, h3, div');
          if (closestBlock && closestBlock.closest('.ProseMirror')) {
            const blockRect = closestBlock.getBoundingClientRect();
            const relativeY = e.clientY - blockRect.top;
            const attempts = [ relativeY, blockRect.height / 2, 5, blockRect.height - 5 ];
            for (const y of attempts) {
              const resolved = view.posAtCoords({ left: clampedX, top: blockRect.top + y });
              if (resolved) { dropPos = resolved; break; }
            }
          }
        }
        if (!dropPos) {
          if (e.clientX >= rect.left - 50 && e.clientX <= rect.right + 50 && e.clientY >= rect.top && e.clientY <= rect.bottom) {
            const relativeY = e.clientY - rect.top;
            const attempts = [ relativeY, relativeY - 10, relativeY + 10, 5, rect.height - 5 ];
            for (const y of attempts) {
              const resolved = view.posAtCoords({ left: clampedX, top: rect.top + y });
              if (resolved) { dropPos = resolved; break; }
            }
          }
        }
        if (!dropPos) {
          const pmDom = view.dom;
          const pmRect = pmDom.getBoundingClientRect();
          if (e.clientY >= pmRect.top && e.clientY <= pmRect.bottom && e.clientX >= pmRect.left - 50 && e.clientX <= pmRect.right + 50) {
            const ratio = (e.clientY - pmRect.top) / pmRect.height;
            const estimatedPos = Math.floor(ratio * view.state.doc.content.size);
            const validPos = Math.max(0, Math.min(estimatedPos, view.state.doc.content.size - 1));
            dropPos = { pos: validPos, inside: validPos };
          }
        }
        if (!dropPos) {
          const validPos = Math.max(0, view.state.doc.content.size - 1);
          dropPos = { pos: validPos, inside: validPos };
        }
        return dropPos;
      }

      function forceDragOver(e: DragEvent) {
        if (view.dragging) {
          if (!hasLoggedDragOver) {
            console.log('[BlockDrag] dragover captured successfully!');
            hasLoggedDragOver = true;
          }
          e.preventDefault();
          e.stopPropagation();
          if (e.dataTransfer) e.dataTransfer.dropEffect = 'move';

          // Show a visual baseline indicator
          let dropPos = getResolvedDropPos(e, view);

          if (dropPos && dropPos.pos >= 0) {
            try {
              let indicatorTop = 0;

              if (dropPos.pos <= 2) {
                const coords = view.coordsAtPos(1); // Get coords of first character
                indicatorTop = coords.top - 2;
              } else {
                const $pos = view.state.doc.resolve(dropPos.pos);
                let depth = $pos.depth;
                while (depth > 0 && !$pos.node(depth).isBlock) {
                  depth--;
                }

                if (depth > 0) {
                  const blockPos = $pos.before(depth);
                  const blockNode = $pos.node(depth);
                  const dom = view.nodeDOM(blockPos) as HTMLElement;
                  if (dom && dom.getBoundingClientRect) {
                    const rect = dom.getBoundingClientRect();
                    if (e.clientY < rect.top + rect.height / 2) {
                      indicatorTop = rect.top - 1;
                      // if it's the heading, force to bottom
                      if (blockNode.type.name === 'heading') {
                        indicatorTop = rect.bottom + 1;
                      }
                    } else {
                      indicatorTop = rect.bottom + 1;
                    }
                  } else {
                    const coords = view.coordsAtPos(dropPos.pos);
                    indicatorTop = coords.top - 1;
                  }
                } else {
                  const coords = view.coordsAtPos(dropPos.pos);
                  indicatorTop = coords.top - 1;
                }

                if (dropPos.pos >= view.state.doc.content.size - 2) {
                  const coords = view.coordsAtPos(dropPos.pos);
                  indicatorTop = Math.max(indicatorTop, coords.bottom + 2);
                }
              }

              let indicator = document.getElementById('block-drag-indicator');
              if (!indicator) {
                indicator = document.createElement('div');
                indicator.id = 'block-drag-indicator';
                indicator.style.position = 'fixed';
                indicator.style.height = '2px';
                indicator.style.backgroundColor = '#1890ff';
                indicator.style.pointerEvents = 'none';
                indicator.style.zIndex = '9999';
                indicator.style.transition = 'top 0.1s ease';
                document.body.appendChild(indicator);
              }
              const editorRect = view.dom.getBoundingClientRect();
              indicator.style.left = `${editorRect.left}px`;
              indicator.style.width = `${editorRect.width}px`;

              indicator.style.top = `${indicatorTop}px`;
              indicator.style.display = 'block';
            } catch (err) {
              // ignore
            }
          }
        }
      }
      function forceDragEnter(e: DragEvent) {
        if (view.dragging) {
          e.preventDefault();
          e.stopPropagation();
          if (e.dataTransfer) e.dataTransfer.dropEffect = 'move';
        }
      }
      function removeIndicator() {
        const indicator = document.getElementById('block-drag-indicator');
        if (indicator) {
          indicator.style.display = 'none';
        }
      }
      function forceDrop(e: DragEvent) {
        if (view.dragging) {
          removeIndicator();
          console.log('[BlockDrag] Executing forceDrop for editor');
          e.preventDefault();
          e.stopPropagation();

          let dropPos = getResolvedDropPos(e, view);

          if (!dropPos) {
            console.log('[BlockDrag] No dropPos found at coordinates', e.clientX, e.clientY);
            return;
          }
          try {
            const { state } = view;
            const { selection } = state;
            const draggedSlice = view.dragging.slice;
            let tr = state.tr;

            // For block moves: if we have a node selection, delete it first
            if (selection instanceof NodeSelection) {
              tr = tr.deleteSelection();
            } else {
              tr = tr.delete(selection.from, selection.to);
            }

            // After deletion, the target position might have shifted, so we map it

            // Calculate exact block boundary insert position BEFORE mapping
            let insertPos = dropPos.pos;
            try {
              if (dropPos.pos <= 2) {
                insertPos = 0;
              } else {
                const $pos = view.state.doc.resolve(dropPos.pos);
                let depth = $pos.depth;
                while (depth > 0 && !$pos.node(depth).isBlock) {
                  depth--;
                }

                if (depth > 0) {
                  const blockPos = $pos.before(depth);
                  const blockNode = $pos.node(depth);
                  const dom = view.nodeDOM(blockPos) as HTMLElement;

                  if (dom && dom.getBoundingClientRect) {
                    const rect = dom.getBoundingClientRect();
                    if (e.clientY < rect.top + rect.height / 2) {
                      insertPos = blockPos; // insert before block
                      // if it's the heading, force to bottom
                      if (blockNode.type.name === 'heading') {
                        insertPos = blockPos + blockNode.nodeSize;
                      }
                    } else {
                      insertPos = blockPos + blockNode.nodeSize; // insert after block
                    }
                  } else {
                    // fallback if DOM is missing
                    if ($pos.parentOffset < $pos.parent.content.size / 2) {
                      insertPos = blockPos;
                    } else {
                      insertPos = blockPos + blockNode.nodeSize;
                    }
                  }
                }
              }
            } catch (err) {}

            const mappedPos = tr.mapping.map(insertPos);

            // final fallback to avoid prepending before heading if insertPos ended up being 0 anyway
            let finalPos = mappedPos;
            if (finalPos === 0) {
              const firstChild = tr.doc.firstChild;
              if (firstChild && firstChild.type.name === 'heading') {
                finalPos = firstChild.nodeSize;
              }
            }

            tr = tr.insert(finalPos, draggedSlice.content);

            view.dispatch(tr);
            console.log('[BlockDrag] Drop successful, dispatched tr');
          } catch (err) {
            console.error('[BlockDrag] Force drop failed', err);
          }
          view.dom.classList.remove('dragging');
          hasLoggedDragOver = false;
        }
      }

      let isDraggingHandleBlock = false;

      function onDragHandleDragStart(e: DragEvent) {
        isDraggingHandleBlock = true;
        hasLoggedDragOver = false;
        handleDragStart(e, view);
        // Bind to document to bypass inner capture stoppers if any
        document.addEventListener('dragover', forceDragOver, { capture: true, passive: false });
        document.addEventListener('dragenter', forceDragEnter, { capture: true, passive: false });
        document.addEventListener('drop', forceDrop, { capture: true, passive: false });
      }
      dragHandleElement.addEventListener('dragstart', onDragHandleDragStart);

      function onDragHandleDrag(e: DragEvent) {
        hideDragHandle();
        let scrollY = window.scrollY;
        if (e.clientY < options.scrollTreshold) {
          window.scrollTo({ top: scrollY - 30, behavior: 'smooth' });
        } else if (window.innerHeight - e.clientY < options.scrollTreshold) {
          window.scrollTo({ top: scrollY + 30, behavior: 'smooth' });
        }
      }

      dragHandleElement.addEventListener('drag', onDragHandleDrag);

      function onDragHandleDragEnd(e: DragEvent) {
        console.log('[BlockDrag] dragHandleElement dragend triggered');
        removeIndicator();
        hideDragHandle();
        restoreLeftMenu();
        view.dom.classList.remove('dragging');
        document.removeEventListener('dragover', forceDragOver, { capture: true });
        document.removeEventListener('dragenter', forceDragEnter, { capture: true });
        document.removeEventListener('drop', forceDrop, { capture: true });
        hasLoggedDragOver = false;
        setTimeout(() => {
          isDraggingHandleBlock = false;
        }, 200);
      }
      dragHandleElement.addEventListener('dragend', onDragHandleDragEnd);


      hideDragHandle();

      if (!handleBySelector) {
        view?.dom?.parentElement?.appendChild(dragHandleElement);
        // 检查是否在模板编辑器弹窗内，如果是则设置更高的 z-index
        const isInTemplateDialog = view?.dom?.closest('.template-editor-dialog');
        if (isInTemplateDialog && dragHandleElement) {
          dragHandleElement.style.zIndex = '10015';
        }
      }
      view?.dom?.parentElement?.addEventListener(
        'mouseout',
        hideHandleOnEditorOut,
      );

      return {
        destroy: () => {
          if (!handleBySelector) {
            dragHandleElement?.remove?.();
          }
          dragHandleElement?.removeEventListener('drag', onDragHandleDrag);
          dragHandleElement?.removeEventListener('dragend', onDragHandleDragEnd);
          dragHandleElement?.removeEventListener(
            'dragstart',
            onDragHandleDragStart,
          );
          dragHandleElement?.removeEventListener(
            'click',
            dragClick,
          );
          dragHandleElement = null;
          view?.dom?.parentElement?.removeEventListener(
            'mouseout',
            hideHandleOnEditorOut,
          );
        },
      };
    },
    props: {
      handleDOMEvents: {
        mousemove: (view, event) => {
          if (!view.editable && !options.showWhenNotEditable) {
            return;
          }
          // debugger
          const node = nodeDOMAtCoords(
            {
              x: event.clientX + 50 + options.dragHandleWidth,
              y: event.clientY,
            },
            options,
          );

          const notDragging = node?.closest('.not-draggable');
          const excludedTagList = options.excludedTags
            .concat(['ol', 'ul'])
            .join(', ');

          if (
            !(node instanceof Element) ||
            node.matches(excludedTagList) ||
            notDragging
          ) {
            hideDragHandle();
            return;
          }
          // 获取 node 在文档中的位置
          const pos = nodePosAtDOM(node, view, options);
          if (typeof pos === 'number' && pos >= 0) {
            selectedDragDocPos = pos;
            const resolvedPos = view.state.doc.resolve(pos);
            selectedDragNode = resolvedPos.nodeAfter || resolvedPos.node();

            selectedDragParentNode = resolvedPos.nodeAfter
                ? resolvedPos.node()
                : resolvedPos.node(resolvedPos.depth - 1);

            // if (selectedDragNode.type.name == 'taskItem'){
            //   let nodeParagraph:any = null;
            //   selectedDragNode.descendants((child,pos)=>{
            //     // console.log("子节点:", child.type.name, "位置:", pos);
            //     if (child.type.name == 'paragraph'){
            //       if (!nodeParagraph){
            //         nodeParagraph = child;
            //       }
            //       return false;//跟没返回似的!*
            //     }
            //     return true; // 继续遍历
            //   })
            //   if (nodeParagraph){
            //     selectedDragNode = nodeParagraph;
            //   }
            // }


            // selectedDragParentPos = findParentNode(node => node.type.name === 'paragraph')(view.state.selection);
            // 拿到hover 对应的 TipTap Node
          }

          if (!dragHandleElement) return;

          const compStyle = window.getComputedStyle(node);

          let rect:any = absoluteRect(node);
          if (view.dom.editor.from == 'cardEdit'){
            const parsedLineHeight = parseFloat(compStyle.lineHeight);
            const fontSize = parseFloat(compStyle.fontSize);
            const lineHeight = Number.isFinite(parsedLineHeight)
                ? parsedLineHeight
                : (Number.isFinite(fontSize) ? fontSize * 1.2 : 0);
            const paddingTop = Number.isFinite(parseFloat(compStyle.paddingTop))
                ? parseFloat(compStyle.paddingTop)
                : 0;

            // Vertically center the block icon relative to the text line box.
            // Use the actual handle height (in local coordinates) instead of a hardcoded number,
            // otherwise it will drift (especially visible across zoom).
            let handleHeight = 18;
            try {
              const fixedContainingBlock = getFixedContainingBlock(node);
              const scale = fixedContainingBlock ? getScaleFromTransform(fixedContainingBlock) : 1;
              const rawHandleH = dragHandleElement.getBoundingClientRect().height;
              handleHeight = fixedContainingBlock ? rawHandleH / (scale || 1) : rawHandleH;
              if (!Number.isFinite(handleHeight) || handleHeight <= 0) {
                handleHeight = 18;
              }
            } catch {
              handleHeight = 18;
            }

            rect.top += (lineHeight - handleHeight) / 2;
            rect.top += paddingTop;
          }else{
            const parsedLineHeight = parseInt(compStyle.lineHeight, 10);
            const lineHeight = isNaN(parsedLineHeight)
                ? parseInt(compStyle.fontSize) * 1.2
                : parsedLineHeight;
            const paddingTop = parseInt(compStyle.paddingTop, 10);

            rect.top += (lineHeight - 24) / 2;
            rect.top += paddingTop;
          }

          // Li markers
          if (node.matches('ul:not([data-type=taskList]) li, ol li')) {
            rect.left -= options.dragHandleWidth;
          }
          rect.width = options.dragHandleWidth;

          // 针对不同节点进行差异化优化
          if (node.tagName === 'LI' && !node.querySelector('li') && node.classList.contains('task-container')) {
            // 如果tasklist里没有嵌套list
            dragHandleElement.style.left = `${rect.left - rect.width - 4}px`;
            dragHandleElement.style.top = `${rect.top + 8}px`;
          }else if (node.tagName === 'LI' && node.querySelector('li') && node.classList.contains('task-container')) {
            // 如果tasklist里有嵌套list
            dragHandleElement.style.left = `${rect.left - rect.width - 12}px`;
            dragHandleElement.style.top = `${rect.top + 7}px`;
          }
          else if (node.tagName === 'LI' && node.querySelector('li') && node.classList.contains('list-container')) {
            // 如果bulletlist/orderlist里有嵌套list
            // dragHandleElement.style.left = `${rect.left - rect.width - 10}px`;
            // dragHandleElement.style.top = `${rect.top + 7}px`;
            // 进一步区分ul ol
            const parentTag = node.parentElement?.tagName;
            if (parentTag === 'UL') {
              dragHandleElement.style.left = `${rect.left - rect.width - 10}px`;
              dragHandleElement.style.top = `${rect.top + 7}px`;
            } else if (parentTag === 'OL') {
              dragHandleElement.style.left = `${rect.left - rect.width - 2}px`;
              dragHandleElement.style.top = `${rect.top + 8}px`;
            }
          }else if (node.tagName === 'DIV' &&  node.classList.contains('node-table')) {
            // 如果bulletlist/orderlist里有嵌套list
            dragHandleElement.style.left = `${rect.left - rect.width - 4}px`;
            dragHandleElement.style.top = `${rect.top - 0}px`;
          }else if (node.tagName === 'HR') {
            // 如果bulletlist/orderlist里有嵌套list
            dragHandleElement.style.left = `${rect.left - rect.width - 2}px`;
            dragHandleElement.style.top = `${rect.top-4}px`;
          }else if (node.tagName === 'LI' && node.classList.contains('list-container')) {
            // 如果bulletlist/orderlist里有嵌套list
            dragHandleElement.style.left = `${rect.left - rect.width - 0}px`;
            dragHandleElement.style.top = `${rect.top + 8}px`;
          }else if (node.tagName === 'LI' && node.classList.contains('task-container')) {
            // 如果tasklist里没有嵌套list
            dragHandleElement.style.left = `${rect.left - rect.width + 10}px`;
            dragHandleElement.style.top = `${rect.top + 10}px`;
          }else if (node.tagName === 'PRE'){
            dragHandleElement.style.left = `${rect.left - rect.width - 2}px`;
            dragHandleElement.style.top = `${rect.top - 0}px`;
          }else if (node.tagName === 'DIV' && node.querySelector('H1')){
            dragHandleElement.style.left = `${rect.left - rect.width + 9}px`;
            dragHandleElement.style.top = `${rect.top + 14}px`;
          }else if (node.tagName === 'DIV' && node.querySelector('H2')){
            dragHandleElement.style.left = `${rect.left - rect.width + 10}px`;
            dragHandleElement.style.top = `${rect.top + 10}px`;
          }else if (node.tagName === 'DIV' && node.querySelector('H3')){
            dragHandleElement.style.left = `${rect.left - rect.width + 10}px`;
            dragHandleElement.style.top = `${rect.top + 8}px`;
          }else if (node.tagName === 'DIV' && node.querySelector('H4')){
            dragHandleElement.style.left = `${rect.left - rect.width + 10}px`;
            dragHandleElement.style.top = `${rect.top + 8}px`;
          }else if (node.tagName === 'DIV' && node.querySelector('H5')){
            dragHandleElement.style.left = `${rect.left - rect.width + 10}px`;
            dragHandleElement.style.top = `${rect.top + 8}px`;
          }else if (node.tagName === 'DIV' && node.querySelector('H6')){
            dragHandleElement.style.left = `${rect.left - rect.width + 10}px`;
            dragHandleElement.style.top = `${rect.top + 8}px`;
          }else if (node.tagName === 'DIV' && node.querySelector('TABLE')){
            dragHandleElement.style.left = `${rect.left - rect.width + 10}px`;
            dragHandleElement.style.top = `${rect.top + 2}px`;
          }
          else {
            dragHandleElement.style.left = `${rect.left - rect.width - 2}px`;
            dragHandleElement.style.top = `${rect.top + 2}px`;
          }

          if (isInDraw() && view.dom.editor.from == 'cardEdit') {//has cardid is cardEdit
            // In canvas cards we want the block icon centered between the card edge
            // and the text start (padding-left midpoint), and vertically centered
            // to the text line box. Compute an absolute target position instead of
            // doing incremental offsets (which are sensitive to per-node branches).
            const fixedContainingBlock = getFixedContainingBlock(node);
            const scale = fixedContainingBlock ? getScaleFromTransform(fixedContainingBlock) : 1;
            const safeScale = scale || 1;

            const paddingLeft = Number.isFinite(parseFloat(compStyle.paddingLeft))
                ? parseFloat(compStyle.paddingLeft)
                : 0;

            // Convert handle size into local coordinates when inside a scaled container.
            const rawHandleRect = dragHandleElement.getBoundingClientRect();
            const handleW = fixedContainingBlock ? rawHandleRect.width / safeScale : rawHandleRect.width;
            const handleH = fixedContainingBlock ? rawHandleRect.height / safeScale : rawHandleRect.height;

            // Horizontal: center icon between card left edge (0) and text start.
            // textStart = rect.left + paddingLeft (local coords from container edge)
            // midpoint  = textStart / 2
            const textStart = rect.left + paddingLeft;
            let desiredLeft = textStart / 2 - handleW / 2;

            // Vertical: rect.top is already centered using lineHeight/handleHeight.
            // Add a tiny nudge upwards in *screen px*, then convert to local coords.
            const dyScreenPx = -2;
            const desiredTop = rect.top + dyScreenPx / safeScale;

            if (node.tagName === 'PRE'){
              desiredLeft -= 8;
            }

            dragHandleElement.style.left = `${desiredLeft}px`;
            dragHandleElement.style.top = `${desiredTop}px`;
          }

          showDragHandle();
        },
        keydown: () => {
          hideDragHandle();
        },
        mousewheel: () => {
          hideDragHandle();
        },
        // dragging class is used for CSS
        dragstart: (view,event) => {
          if (APP_WEB){
            event.stopPropagation();
            event.preventDefault();
            return;
          }

          view.dom.classList.add('dragging');
        },
        drop: (view, event) => {
          // 拖动结束
          view.dom.classList.remove('dragging');
          hideDragHandle();
          let droppedNode: Node | null = null;
          const dropPos = view.posAtCoords({
            left: event.clientX,
            top: event.clientY,
          });

          if (!dropPos) return;

          if (view.state.selection instanceof NodeSelection) {
            droppedNode = view.state.selection.node;
          }
          if (!droppedNode) return;

          const resolvedPos = view.state.doc.resolve(dropPos.pos);
          const resolvedLastPos = view.state.doc.resolve(dropPos.pos - 1);
          const resolvedParentNode = resolvedLastPos.node(resolvedLastPos.depth - 1);
          const resolvedGrandParentNode =
            resolvedLastPos.depth >= 2 ? resolvedLastPos.node(resolvedLastPos.depth - 2) : null;

          const resolvedLastNode = resolvedLastPos.node();

          const isDroppedInsideList =
            resolvedPos.parent.type.name === 'listItem';
          
          // 如果是table需要删除原来位置的table


          // If the selected node is a list item and is not dropped inside a list, we need to wrap it inside <ol> tag otherwise ol list items will be transformed into ul list item when dropped
          if (
            view.state.selection instanceof NodeSelection &&
            view.state.selection.node.type.name === 'listItem' &&
            !isDroppedInsideList &&
            listType == 'OL' && !(resolvedLastNode.type.name === 'paragraph' && resolvedParentNode.type.name === 'listItem' && resolvedGrandParentNode?.type?.name === 'orderedList')
          ) {
            // debugger
            const newList = view.state.schema.nodes.orderedList?.createAndFill(
              null,
              droppedNode,
            );
            const slice = new Slice(Fragment.from(newList), 0, 0);
            view.dragging = { slice, move: event.ctrlKey };
          }
        },
        dragend: (view) => {
          view.dom.classList.remove('dragging');
        },
      },
    },
  });
}

const GlobalDragHandle = Extension.create({
  name: 'globalDragHandle',

  addOptions() {
    return {
      dragHandleWidth: 20,
      scrollTreshold: 100,
      excludedTags: [],
      customNodes: [],
      from:''
    };
  },

  addProseMirrorPlugins() {
    return [
      DragHandlePlugin({
        pluginKey: 'globalDragHandle',
        dragHandleWidth: this.options.dragHandleWidth,
        scrollTreshold: this.options.scrollTreshold,
        dragHandleSelector: this.options.dragHandleSelector,
        excludedTags: this.options.excludedTags,
        customNodes: this.options.customNodes,
        callback:this.options.callback,
      }),
    ];
  },
});

export default GlobalDragHandle;
